import NextLazyImage from "@/components/Core/NextLazyImage";
import mq from "@/utils/mq";
import React from "react";
import styled, { css } from "styled-components";
import BentoIconGrid from "./BentoIconGrid";

const BentoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  flex: 0 0 33%;
  background-color: #141516;
  border-radius: 16px;
  gap: 2px;
  overflow: hidden;
  ${mq.mobile(css`
    flex: unset;
    height: fit-content;

    > div {
      aspect-ratio: 2/1;
    }
  `)};
`;

export default function SmallBentoGridItem({ item }: { item: any }) {
  return <BentoContainer>{item?.component === "bentoIconGrid" && <BentoIconGrid item={item} />}</BentoContainer>;
}
